import { render, staticRenderFns } from "./OnboardingHeading.vue?vue&type=template&id=c95ad138&"
import script from "./OnboardingHeading.vue?vue&type=script&lang=js&"
export * from "./OnboardingHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports